module.exports = __webpack_public_path__ + "static/media/img-backgroud-groc-pattern2x.799e2e52.png";